import axios from 'axios';

export default {
  async getPolicyList(context, { page }) {
    try {
      //const codeCountry = await context.rootGetters['general/getCountryCode'];
      const response = await this.$axios.get(
        `${process.env.API_BASE_URL}/accomm/policies/list?page=${page}&limit=20&descending=true`
      );
      context.commit('updatePolicyList', response.data.data);
      return response;
    } catch (err) {
      console.log(err);
      return err;
    }
  },
  async getClaimList(context, { page }) {
    try {
      // const query = `orderBy=updatedAt&&limit=7&&page=${page}`;
      console.log('update', page);
      const query = `orderBy=updatedAt`;
      const { data } = await this.$axios.get(`/accomm/claims?${query}`);
      const response = data;
      console.log('update', response);
      console.log('masukes');
      context.commit('updateClaimList', response);
      return response;
    } catch (error) {
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      return errorData;
    }
  },
  async getDocumentsType(context) {
    try {
      let link = `${process.env.API_BASE_URL}/accomm/documents/types`;
      const { data } = await axios.get(link);
      const result = data.data;
      context.commit('updateDocumentsType', result);
    } catch (error) {
      const errorResponse = error.response;
      return errorResponse;
    }
  },
  async getOTAList(context) {
    try {
      const codeCountry = await context.rootGetters['general/getCountryCode'];

      let link = `${process.env.API_BASE_URL}/accomm/ota-channels/list?country=${codeCountry}`;
      const {
        data: { data }
      } = await axios.get(link);
      const OTAList = data.map(item => {
        return { value: item.otaCode, label: item.otaName };
      });
      context.commit('updateOTAList', OTAList);
      return OTAList;
    } catch (error) {
      const errorResponse = error.response;
      return errorResponse;
    }
  }
};
